class LaEpicMobileMenu extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';

    // Keep older cached markup usable while Shopify refreshes the theme HTML:
    // the category name becomes the trigger and the separate arrow is hidden.
    this.querySelectorAll('.le-mobile-menu__row').forEach((row) => {
      const link = row.querySelector(':scope > .le-mobile-menu__link');
      const toggle = row.querySelector(':scope > [data-le-menu-toggle]');
      if (!link || !toggle || link === toggle) return;

      link.dataset.leMenuProxyToggle = 'true';
      link.setAttribute('role', 'button');
      link.setAttribute('aria-controls', toggle.getAttribute('aria-controls'));
      link.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') || 'false');
      toggle.setAttribute('aria-hidden', 'true');
      toggle.tabIndex = -1;
    });

    this.addEventListener('click', (event) => {
      const directToggle = event.target.closest('[data-le-menu-toggle]');
      const proxyLink = event.target.closest('[data-le-menu-proxy-toggle]');
      const toggle = directToggle || proxyLink?.closest('.le-mobile-menu__row')?.querySelector(':scope > [data-le-menu-toggle]');
      if (!toggle || !this.contains(toggle)) return;

      // Trade's MenuDrawer binds every internal button as a close control.
      // Intercept our expanders during capture so that handler never runs.
      event.preventDefault();
      event.stopPropagation();

      const controlledId = toggle.getAttribute('aria-controls');
      const submenu = controlledId ? document.getElementById(controlledId) : null;
      if (!submenu) return;

      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(willOpen));
      proxyLink?.setAttribute('aria-expanded', String(willOpen));
      submenu.hidden = !willOpen;
    }, true);
  }
}

if (!customElements.get('la-epic-mobile-menu')) {
  customElements.define('la-epic-mobile-menu', LaEpicMobileMenu);
}
